module.exports = kolibriCoreAppGlobal.urls;